import React, { useEffect } from 'react'
import { Text, Loader, Icon } from './'

const NextModal = ({
  style = {},
  className = '',
  theme = '',
  title,
  children,
  actions,
  loading,
  close,
  loaderClassname = '',
  withHeader = true,
  withFooter = true
}) => {
  useEffect(() => {
    document.addEventListener('keydown', (e) => {
      e = e || window.event
      if (e.keyCode === 27) close()
    })
  }, [close])

  return (
    <div
      style={{ style }}
      className={`ui gp-next-modal ${className} ${theme}`}
      onClick={close}
    >
      <div onClick={(e) => e.stopPropagation()}>
        {withHeader && (
          <header>
            <Text className='semibold text-g'>{title}</Text>
            <div className='control-container dark close-btn'>
              <button onClick={close}>
                <Icon name='close' />
              </button>
            </div>
          </header>
        )}
        <div className='main'>{children}</div>
        {withFooter && (
          <footer className={actions ? 'with-actions' : ''}>{actions}</footer>
        )}
        {loading && (
          <Loader className={loaderClassname} icon dark full withBackground />
        )}
      </div>
    </div>
  )
}

export default NextModal
